import {
  AtTagFolioStatus,
  AtTagNumberVariant,
  AtTagAccountsStatus,
  AtTagType,
} from "../../../atoms";
import { TableCellType, TableRow } from "../or-table.type";

const CLIENT_MOCK_DATA = [
  {
    name: "Juan Pérez",
    email: "juan.perez@email.com",
    birthDate: "1990-05-15",
    regDate: "2023-01-10",
  },
  {
    name: "María González",
    email: "maria.gonzalez@email.com",
    birthDate: "1985-12-03",
    regDate: "2023-02-15",
  },
  {
    name: "Carlos Rodríguez",
    email: "carlos.rodriguez@email.com",
    birthDate: "1992-08-22",
    regDate: "2023-03-08",
  },
  {
    name: "Ana Martínez",
    email: "ana.martinez@email.com",
    birthDate: "1988-04-11",
    regDate: "2023-01-25",
  },
  {
    name: "Luis Hernández",
    email: "luis.hernandez@email.com",
    birthDate: "1995-11-30",
    regDate: "2023-04-12",
  },
  {
    name: "Carmen López",
    email: "carmen.lopez@email.com",
    birthDate: "1987-07-18",
    regDate: "2023-02-28",
  },
  {
    name: "Roberto García",
    email: "roberto.garcia@email.com",
    birthDate: "1991-03-25",
    regDate: "2023-05-05",
  },
  {
    name: "Isabel Sánchez",
    email: "isabel.sanchez@email.com",
    birthDate: "1989-09-14",
    regDate: "2023-01-18",
  },
  {
    name: "Miguel Torres",
    email: "miguel.torres@email.com",
    birthDate: "1993-06-07",
    regDate: "2023-03-22",
  },
  {
    name: "Patricia Flores",
    email: "patricia.flores@email.com",
    birthDate: "1986-01-29",
    regDate: "2023-04-30",
  },
  {
    name: "Fernando Ruiz",
    email: "fernando.ruiz@email.com",
    birthDate: "1994-10-16",
    regDate: "2023-02-10",
  },
  {
    name: "Laura Jiménez",
    email: "laura.jimenez@email.com",
    birthDate: "1987-12-08",
    regDate: "2023-05-15",
  },
  {
    name: "Diego Morales",
    email: "diego.morales@email.com",
    birthDate: "1990-02-13",
    regDate: "2023-01-30",
  },
  {
    name: "Sofía Vargas",
    email: "sofia.vargas@email.com",
    birthDate: "1992-05-26",
    regDate: "2023-03-14",
  },
  {
    name: "Andrés Castillo",
    email: "andres.castillo@email.com",
    birthDate: "1988-08-19",
    regDate: "2023-04-08",
  },
  {
    name: "Valentina Herrera",
    email: "valentina.herrera@email.com",
    birthDate: "1991-11-04",
    regDate: "2023-02-22",
  },
  {
    name: "Sebastián Ramos",
    email: "sebastian.ramos@email.com",
    birthDate: "1989-07-12",
    regDate: "2023-05-02",
  },
  {
    name: "Camila Aguilar",
    email: "camila.aguilar@email.com",
    birthDate: "1993-04-17",
    regDate: "2023-01-12",
  },
  {
    name: "Nicolás Vega",
    email: "nicolas.vega@email.com",
    birthDate: "1986-09-23",
    regDate: "2023-03-28",
  },
  {
    name: "Daniela Mendoza",
    email: "daniela.mendoza@email.com",
    birthDate: "1994-12-01",
    regDate: "2023-04-18",
  },
];

export const OR_TABLE_CLIENTS_MOCK: TableRow[] = CLIENT_MOCK_DATA.map(
  (client, index) => ({
    id: `client-${index + 1}`,
    cells: [
      { type: TableCellType.TEXT, value: client.name },
      { type: TableCellType.TEXT, value: client.email },
      { type: TableCellType.TEXT, value: client.birthDate },
      { type: TableCellType.TEXT, value: client.regDate },
      {
        type: TableCellType.BUTTON,
        value: "Iniciar atencion",
        onClick: () => console.log(`Start attention for ${client.name}`),
        align: "center",
      },
    ],
  }),
);

const ORDER_MOCK_DATA = [
  {
    orderNumber: "54324456",
    customerName: "Alejandra Fernandez Gonzalez",
    date: "03-May-2010",
  },
  {
    orderNumber: "54324457",
    customerName: "Roberto Silva Mendoza",
    date: "15-Mar-2011",
  },
  {
    orderNumber: "54324458",
    customerName: "Carmen Delgado Ruiz",
    date: "22-Jul-2012",
  },
  {
    orderNumber: "54324459",
    customerName: "Miguel Torres López",
    date: "08-Nov-2010",
  },
  {
    orderNumber: "54324460",
    customerName: "Isabel Morales Castro",
    date: "14-Apr-2013",
  },
  {
    orderNumber: "54324461",
    customerName: "Fernando Herrera Vega",
    date: "29-Sep-2011",
  },
  {
    orderNumber: "54324462",
    customerName: "Patricia Ramos Jiménez",
    date: "06-Dec-2012",
  },
  {
    orderNumber: "54324463",
    customerName: "Diego Aguilar Flores",
    date: "18-Feb-2010",
  },
  {
    orderNumber: "54324464",
    customerName: "Laura Castillo Sánchez",
    date: "25-Aug-2013",
  },
  {
    orderNumber: "54324465",
    customerName: "Sebastián Vargas García",
    date: "11-Jun-2011",
  },
];

export const OR_TABLE_ORDERS_MOCK: TableRow[] = ORDER_MOCK_DATA.map(
  (order, index) => ({
    id: `order-${index + 1}`,
    cells: [
      {
        type: TableCellType.BADGE,
        tagProps: {
          label: order.orderNumber,
          type: AtTagType.NUMBER,
          variant: AtTagNumberVariant.ORDER,
        },
      },
      { type: TableCellType.TEXT, value: order.customerName },
      { type: TableCellType.TEXT, value: order.date },
      {
        type: TableCellType.BUTTON,
        value: "Ver seguimiento",
        onClick: () =>
          console.log(`See tracking for order ${order.orderNumber}`),
        align: "center",
      },
    ],
  }),
);

const FOLIO_MOCK_DATA = [
  {
    folioNumber: "0426781",
    customerName: "Alejandra Fernandez Gonzalez",
    email: "alejandra.fernandez@email.com",
    date: "03-May-2010",
    status: AtTagFolioStatus.OPEN,
  },
  {
    folioNumber: "0426782",
    customerName: "Carlos Mendoza Silva",
    email: "carlos.mendoza@email.com",
    date: "15-Mar-2011",
    status: AtTagFolioStatus.CLOSED,
  },
  {
    folioNumber: "0426783",
    customerName: "María Delgado Ruiz",
    email: "maria.delgado@email.com",
    date: "22-Jul-2012",
    status: AtTagFolioStatus.OPEN,
  },
  {
    folioNumber: "0426784",
    customerName: "Luis Torres López",
    email: "luis.torres@email.com",
    date: "08-Nov-2010",
    status: AtTagFolioStatus.ACTIVE,
  },
  {
    folioNumber: "0426785",
    customerName: "Ana Morales Castro",
    email: "ana.morales@email.com",
    date: "14-Apr-2013",
    status: AtTagFolioStatus.OPEN,
  },
  {
    folioNumber: "0426786",
    customerName: "Roberto Herrera Vega",
    email: "roberto.herrera@email.com",
    date: "29-Sep-2011",
    status: AtTagFolioStatus.CLOSED,
  },
  {
    folioNumber: "0426787",
    customerName: "Carmen Ramos Jiménez",
    email: "carmen.ramos@email.com",
    date: "06-Dec-2012",
    status: AtTagFolioStatus.OPEN,
  },
  {
    folioNumber: "0426788",
    customerName: "Miguel Aguilar Flores",
    email: "miguel.aguilar@email.com",
    date: "18-Feb-2010",
    status: AtTagFolioStatus.ACTIVE,
  },
  {
    folioNumber: "0426789",
    customerName: "Isabel Castillo Sánchez",
    email: "isabel.castillo@email.com",
    date: "25-Aug-2013",
    status: AtTagFolioStatus.OPEN,
  },
  {
    folioNumber: "0426790",
    customerName: "Fernando Vargas García",
    email: "fernando.vargas@email.com",
    date: "11-Jun-2011",
    status: AtTagFolioStatus.CLOSED,
  },
];

export const OR_TABLE_FOLIOS_MOCK: TableRow[] = FOLIO_MOCK_DATA.map(
  (folio, index) => ({
    id: `folio-${index + 1}`,
    cells: [
      {
        type: TableCellType.BADGE,
        tagProps: {
          label: folio.folioNumber,
          type: AtTagType.NUMBER,
          variant: AtTagNumberVariant.FOLIO,
        },
      },
      { type: TableCellType.TEXT, value: folio.customerName },
      { type: TableCellType.TEXT, value: folio.email },
      { type: TableCellType.TEXT, value: folio.date },
      {
        type: TableCellType.BADGE,
        tagProps: {
          type: AtTagType.FOLIO,
          status: folio.status,
        },
      },
      {
        type: TableCellType.BUTTON,
        value: "Retomar folio",
        onClick: () => console.log(`Retomar folio ${folio.folioNumber}`),
        align: "center",
      },
    ],
  }),
);

const AGENT_MOCK_DATA = [
  {
    employeeNumber: "16804173",
    name: "Neftalí Caravantes Gutiérrez",
    email: "ncaravantesg@liverpool.com.mx",
    campaign: "Ventel",
    status: AtTagAccountsStatus.ACTIVE,
  },
  {
    employeeNumber: "16804174",
    name: "María Elena Rodríguez López",
    email: "mrodriguez@liverpool.com.mx",
    campaign: "Soporte",
    status: AtTagAccountsStatus.ACTIVE,
  },
  {
    employeeNumber: "16804175",
    name: "Carlos Alberto Silva Mendoza",
    email: "csilva@liverpool.com.mx",
    campaign: "Ventas",
    status: AtTagAccountsStatus.INACTIVE,
  },
  {
    employeeNumber: "16804176",
    name: "Ana Patricia González Ruiz",
    email: "agonzalez@liverpool.com.mx",
    campaign: "Ventel",
    status: AtTagAccountsStatus.ACTIVE,
  },
  {
    employeeNumber: "16804177",
    name: "Luis Fernando Torres Castro",
    email: "ltorres@liverpool.com.mx",
    campaign: "Soporte",
    status: AtTagAccountsStatus.ACTIVE,
  },
  {
    employeeNumber: "16804178",
    name: "Carmen Delia Morales Vega",
    email: "cmorales@liverpool.com.mx",
    campaign: "Ventas",
    status: AtTagAccountsStatus.INACTIVE,
  },
  {
    employeeNumber: "16804179",
    name: "Roberto Javier Herrera Flores",
    email: "rherrera@liverpool.com.mx",
    campaign: "Ventel",
    status: AtTagAccountsStatus.ACTIVE,
  },
  {
    employeeNumber: "16804180",
    name: "Isabel Cristina Ramos Sánchez",
    email: "iramos@liverpool.com.mx",
    campaign: "Soporte",
    status: AtTagAccountsStatus.ACTIVE,
  },
  {
    employeeNumber: "16804181",
    name: "Miguel Ángel Aguilar García",
    email: "maguilar@liverpool.com.mx",
    campaign: "Ventas",
    status: AtTagAccountsStatus.INACTIVE,
  },
  {
    employeeNumber: "16804182",
    name: "Patricia Elena Castillo Jiménez",
    email: "pcastillo@liverpool.com.mx",
    campaign: "Ventel",
    status: AtTagAccountsStatus.ACTIVE,
  },
];

export const OR_TABLE_AGENTS_MOCK: TableRow[] = AGENT_MOCK_DATA.map(
  (agent, index) => ({
    id: `agent-${index + 1}`,
    cells: [
      {
        type: TableCellType.BADGE,
        tagProps: {
          label: agent.employeeNumber,
          type: AtTagType.NUMBER,
          variant: AtTagNumberVariant.EMPLOYEE_NUMBER,
        },
      },
      { type: TableCellType.TEXT, value: agent.name },
      { type: TableCellType.TEXT, value: agent.email },
      {
        type: TableCellType.BADGE,
        tagProps: {
          type: AtTagType.CAMPAIGNS,
          label: agent.campaign,
        },
      },
      {
        type: TableCellType.BADGE,
        tagProps: {
          type: AtTagType.ACCOUNTS,
          status: agent.status,
        },
      },
    ],
  }),
);
